module.exports = __webpack_public_path__ + "static/blog-splash-1-7b325da7501498c980167dfe370a0aa7.jpg";